export interface MenuNode {
  key: string | number
  link?: string | null
  subMenu?: MenuNode[]
}

export interface MenuMatch {
  selectedKey?: string
  ancestorKeys: string[]
}

export type OpenKeyAction =
  | { type: 'navigate'; ancestorKeys: string[] }
  | { type: 'toggle'; openKeys: string[] }

export function menuItemPath(link?: string | null): string | undefined {
  if (!link) return undefined
  const path = link.split('?')[0]
  return path || undefined
}

export function matchMenu(pathname: string, menus: MenuNode[]): MenuMatch {
  return findMatch(pathname, menus, []) ?? { ancestorKeys: [] }
}

function findMatch(
  pathname: string,
  menus: MenuNode[],
  ancestors: string[],
): MenuMatch | undefined {
  for (const item of menus) {
    if (menuItemPath(item.link) === pathname) {
      return { selectedKey: String(item.key), ancestorKeys: ancestors }
    }
    if (item.subMenu && item.subMenu.length > 0) {
      const nested = findMatch(pathname, item.subMenu, [...ancestors, String(item.key)])
      if (nested) return nested
    }
  }
  return undefined
}

export function updateOpenKeys(openKeys: string[], action: OpenKeyAction): string[] {
  if (action.type === 'toggle') return [...action.openKeys]
  const next = [...openKeys]
  for (const key of action.ancestorKeys) {
    if (!next.includes(key)) next.push(key)
  }
  return next
}
